import { render } from "./tambah.vue?vue&type=template&id=8307fc28"
import script from "./tambah.vue?vue&type=script&lang=js"
export * from "./tambah.vue?vue&type=script&lang=js"

import "./tambah.vue?vue&type=style&index=0&id=8307fc28&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__